import React from 'react';
import { CustomInputStyle } from '../input/style'

function CustomInput ({placeholder,sx, className,type,onChange, value}) {
    return (
           <CustomInputStyle type={type} className={className} sx={sx} placeholder={placeholder} fullWidth onChange={onChange} value={value}/>
    )
}

export default CustomInput